module.exports = __webpack_public_path__ + "img/qyhj.391aaf7d.png";